module.exports = __webpack_public_path__ + "static/media/bg16.0e1ba9af.png";